window._ = require("underscore");
window.Dropzone = require("dropzone");
window.messageResource = require("./messageResource").default;

window.FeaturesPage = require('./administration/features').default

const loginModule = require("./login")
window.BaseLoginPageState = loginModule.BaseLoginPageState
window.LoginState = loginModule.LoginState
window.ForgetPasswordState = loginModule.ForgetPasswordState
window.ResetPasswordState = loginModule.ResetPasswordState
window.ErrorState = loginModule.ErrorState

window.LoginPageController = require("./login_page_controller").LoginPageController
window.ActivationPageController = require("./activation_page_controller").default

window.ClientSideErrors = require('./client_side_errors').default
require("./base_settings")
require("./navigation_resize")

window.RegExpSpecialSymbols = require("./util/RegExpSpecialSymbols").default;
window.DiacriticsUtil = require("./util/DiacriticsUtil").default;
window.StringTokenizer = require("./util/StringTokenizer").default;
window.StringIndex = require("./util/StringIndex").default;
window.EntityStore = require("./store/EntityStore").default;
window.CustomerStore = require("./store/CustomerStore").default;
window.ProjectStore = require("./store/ProjectStore").default;
window.TaskStore = require("./store/TaskStore").default;
window.BillingTypeStore = require("./store/BillingTypeStore").default;
window.BillingType = require("./store/BillingType").default;
window.CustomerProjectSelection = require("./CustomerProjectSelection").default;
window.KEY_HANDLERS = require("./keyHandlers/").default;
window.View = require("./View").default;
window.TemplateView = require("./TemplateView").default;
window.Tooltip = require("./Tooltip").default;
window.SimpleTooltip = require("./SimpleTooltip").default;
window.ScrollView = require("./ScrollView").default;
window.DropdownTemplateView = require("./DropdownTemplateView").default;
window.AuditHistoryView = require("./panels/auditHsitory/AuditHistoryView").default;
window.LoadingControlMixin = require("./controls/LoadingControlMixin").default;
window.WindowSizeDependedView = require("./WindowSizeDependedView").default;
window.CPSelectorController = require("./user/add_tasks/cp_selector_controller").default;
window.TaskListController = require("./user/add_tasks/TaskListController").default;
window.userStore = require("./store/userStore").default;
window.User = require("./store/User").default;
window.UserWithAccessRights = require("./store/UserWithAccessRights").default;
window.Group = require("./store/Group").default;
window.Pager = require("./pager/Pager").default;
window.PagerController = require("./pager/PagerController").default;
window.TreeNode = require("./hierarchySelector/tree/TreeNode").default;
window.TreeNodeSet = require("./hierarchySelector/tree/TreeNodeSet").default;
window.TreeFilter = require("./hierarchySelector/tree/TreeFilter").default;
window.SelectorFilter = require("./hierarchySelector/tree/SelectorFilter").default;
window.SimpleCheckboxNodeRenderer = require("./hierarchySelector/tree/SimpleCheckboxNodeRenderer").default;
window.HierarchySelectorNodeRenderer = require("./hierarchySelector/tree/HierarchySelectorNodeRenderer").default;
window.TriStateCheckboxTreeNodeRenderer = require("./hierarchySelector/tree/TriStateCheckboxTreeNodeRenderer").default;
window.SelectionTreeNodeRenderer = require("./hierarchySelector/selectionTree/SelectionTreeNodeRenderer").default;
window.TreeNodeRenderer = require("./hierarchySelector/tree/TreeNodeRenderer").default;
window.DisabledNodesParentTreeNode = require("./hierarchySelector/tree/DisabledNodesParentTreeNode").default;
window.HierarchySelectorUtil = require("./controls/selectorControls/hierarchy_selector_util").default;
window.TwoLevelSelection = require("./controls/selectorControls/two_level_selection").default;
window.CoarseSelection = require("./enums/CoarseSelection").default;
window.FilterWordsField = require("./controls/FilterWordsField").default;
window.FilterWordsPopup = require("./controls/filter_words_popup").default;
window.KeyDownHandler = require("./key_down_handler").default;
window.TokensHighlighter = require("./util/TokensHighlighter").default;
window.EmptyHighlighter = require("./util/EmptyHighlighter").default;
window.AtMap = require("./util/AtMap").default;
window.DhtmlPopup = require("./dhtml_popup").default;
window.RelativePositioning = require("./dhtml_popup").RelativePositioning;
window.ElementRelativePositioning = require("./dhtml_popup").ElementRelativePositioning;
window.ElementRelativeOnTheRightEdgePositioning = require("./dhtml_popup").ElementRelativeOnTheRightEdgePositioning;
window.ElementRelativeInTheContainerPositioning = require("./dhtml_popup").ElementRelativeInTheContainerPositioning;
window.ShowHideByDisplayPropertyStrategy = require("./dhtml_popup").ShowHideByDisplayPropertyStrategy;
window.ShowHideByVisibilityPropertyStrategy = require("./dhtml_popup").ShowHideByVisibilityPropertyStrategy;
window.ScrollUtils = require("./util/ScrollUtils").default;
window.UserNameFormat = require("./util/UserNameFormat").default;
window.BalanceFormatter = require("./util/BalanceFormatter").BalanceFormatter;
window.SickFormatter = require("./util/BalanceFormatter").SickFormatter;
window.PTOFormatter = require("./util/BalanceFormatter").PTOFormatter;
window.LoadingMoire = require("./LoadingMoire").default;
window.OnlineAccountFieldsEditUserPopupDrawer = require("./administration/userManagement/OnlineAccountFieldsUserPopupDrawer").OnlineAccountFieldsEditUserPopupDrawer;
window.OnlineAccountFieldsCreateUserPopupDrawer = require("./administration/userManagement/OnlineAccountFieldsUserPopupDrawer").OnlineAccountFieldsCreateUserPopupDrawer;
window.DownloadableAccountFieldsCreateUserPopupDrawer = require("./administration/userManagement/DownloadableAccountFieldsUserPopupDrawer").DownloadableAccountFieldsCreateUserPopupDrawer;
window.DownloadableAccountFieldsEditUserPopupDrawer = require("./administration/userManagement/DownloadableAccountFieldsUserPopupDrawer").DownloadableAccountFieldsEditUserPopupDrawer;
window.UserNameDrawer = require("./administration/userManagement/UserNameDrawer").default;
window.InvitationDrawer = require("./administration/userManagement/InvitationDrawer").default;
window.PasswordFieldsDrawer = require("./administration/userManagement/PasswordFieldsDrawer").default;
window.CPReportSelector = require("./cp_selector/cp_selector_report_config.js").default;
window.DropdownDialog = require('./controls/DropdownDialog').default;
window.DropdownDialogWithPointerWrapper = require('./components/DropdownDialogWithPointerWrapper').default;
window.SpinnerController = require('./SpinnerController').default;
window.TimeZonesSelector = require('./controls/TimeZonesSelector').default;
window.GroupType = require('./enums/GroupType').default;
window.ShowUserGroupsStrategy = require('./usersSelector/userSelectorGroupsStrategies/ShowUserGroupsStrategy').default;
window.HideUserGroupsStrategy = require('./usersSelector/userSelectorGroupsStrategies/HideUserGroupsStrategy').default;
window.TriStateSelectorTree = require('./hierarchySelector/selectionTree/TriStateSelectorTree').default;
window.Tree = require('./hierarchySelector/tree/Tree').default;
window.TreeRootNode = require('./hierarchySelector/tree/TreeRootNode').default;
window.UserTreeNode = require('./hierarchySelector/tree/UserTreeNode').default;
window.DisabledNodesParentNodeRenderer = require('./hierarchySelector/tree/DisabledNodesParentNodeRenderer').default;
window.UserNodeRenderer = require('./hierarchySelector/userSelector/UserNodeRenderer').default;
window.UserGroupNodeRenderer = require('./hierarchySelector/userSelector/UserGroupNodeRenderer').default;
window.TimeZoneGroupNodeRenderer = require('./hierarchySelector/userSelector/TimeZoneGroupNodeRenderer').default;
window.EmailCheckUserNodeRenderer = require('./hierarchySelector/userSelector/EmailCheckUserNodeRenderer').default;
window.EmptyMessageBuilder = require('./hierarchySelector/userSelector/emptyMessagesBuilders/EmptyMessageBuilder').default;
window.UserSelectorEmptyMessageBuilder = require('./hierarchySelector/userSelector/emptyMessagesBuilders/UserSelectorEmptyMessageBuilder').default;
window.TriStateSelectionController = require('./hierarchySelector/tree/TriStateSelectionController').default;
window.ExpandCollapseNodeRenderer = require('./hierarchySelector/tree/ExpandCollapseNodeRenderer').default;
window.CustomerNodeRenderer = require('./hierarchySelector/customerProjectSelector/CustomerNodeRenderer').default;
window.ProjectNodeRenderer = require('./hierarchySelector/customerProjectSelector/ProjectNodeRenderer').default;
window.ArchivedCustomersParentNodeRenderer = require('./hierarchySelector/customerProjectSelector/ArchivedCustomersParentNodeRenderer').default;
window.ArchivedProjectsParentNodeRenderer = require('./hierarchySelector/customerProjectSelector/ArchivedProjectsParentNodeRenderer').default;
window.TreeBuilder = require('./usersSelector/builder/TreeBuilder').default;
window.UserSelectorTreeBuilder = require('./usersSelector/builder/UserSelectorTreeBuilder').default;
window.UserSelectorTreeBuilderObserver = require('./usersSelector/builder/UserSelectorTreeBuilderObserver').default;
window.TimeZoneGroupValidatorStrategy = require('./util/GroupValidatorStrategy').TimeZoneGroupValidatorStrategy;
window.UserGroupValidatorStrategy = require('./util/GroupValidatorStrategy').UserGroupValidatorStrategy;
window.SelectorPanelWithApplyButtonHelper = require('./controls/selectorControls/at_selector_panel_with_apply_button_object').default;
window.GUIControl = require('./controls/gui_control').default;
window.DropdownButton = require('./controls/dropdown_button').default;
window.DhtmlTitle = require('./dhtml_title').default;
window.AncestorEventsListenerMixin = require('./AncestorEventsMixins').AncestorEventsListenerMixin;
window.AncestorEventsEmitterMixin = require('./AncestorEventsMixins').AncestorEventsEmitterMixin;
window.DescendantEventsListenerMixin = require('./AncestorEventsMixins').DescendantEventsListenerMixin;
window.DescendantEventsEmitterMixin = require('./AncestorEventsMixins').DescendantEventsEmitterMixin;
window.PermissionsTemplateButtonControllerWithoutChoosing = require('./administration/userManagement/permissionsTemplates/PermissionsTemplateButtonControllerWithoutChoosing').default;
window.ListSelector = require('./controls/ListSelector').default;
window.SimpleListMenuButton = require('./SimpleListMenuButton').default;
window.TaskPanel = require('./panels/task/TaskPanel').default;
window.ProjectPanel = require('./panels/project/ProjectPanel').default;
window.CustomerPanel = require('./panels/customer/CustomerPanel').default;
window.MoveToDialog = require('./panels/MoveToDialog').default;
window.DateRange = require('./DateRange').default;
window.LockTTTableController = require('./user/locktt/LockTTTableController').default;
window.LockTTStore = require('./user/locktt/LockTTStore').default
window.ProjectPanelController = require('./panels/project/ProjectPanelController').default
window.CustomerPanelController = require('./panels/customer/CustomerPanelController').default
window.DHTMLPopupWithMoire = require('./dhtml_popup_with_moire').default
window.LoadingPopup = require('./LoadingPopup').default
window.BasicLightbox = require('./BasicLightbox').default
window.CreateReportPopup = require('./reports/dashboard/createReportPopup/CreateReportPopup').default
window.BaseFormatterCreator = require('./reports/charts/parametersFormatters/BaseFormatterCreator').default
window.ReportChartUtils = require('./reports/ReportChartUtils').default
window.CreateTasksLightboxUtils = require('./addNewTasks/utils') // TODO temporary
window.NoNotificationMessageParams = require('./usersSelector/NoNotificationMessageParams').default;
window.MailNotificationsUserSelectorCache = require('./usersSelector/builder/MailNotificationsUserSelectorCache').default;
window.FeatureDiffStateController = require('./FeaturesDiffStateController').default
window.RpcControlManager = require('./rpc_control_manager').default;
window.BaseGroupManagementController = require('./groupManagement/base_group_management_controller').BaseGroupManagementController;
window.TimeZoneGroupManagementController = require('./groupManagement/base_group_management_controller').TimeZoneGroupManagementController;
window.UserGroupRenderer = require('./groupManagement/user_group_renderer').default;
window.TimeZoneGroupRenderer = require('./groupManagement/time_zone_group_renderer').default;
window.GroupDataRetrieveRPCManager = require('./groupManagement/rpc/group_data_retrieve_rpc_manager').default;
window.GroupManagementUtil = require('./groupManagement/group_management_util').default;
window.GroupRow = require('./groupManagement/entities/GroupRow').default;
window.GroupWithUsers = require('./groupManagement/entities/GroupWithUsers').default;
window.TimeZoneGroupRow = require('./groupManagement/entities/TimeZoneGroupRow').default;
window.UserInGroup = require('./groupManagement/entities/UserInGroup').default;
window.UserInGroupRow = require('./groupManagement/entities/UserInGroupRow').default;
window.AddGroupController = require('./groupManagement/add_group_controller').default;
window.LeaveTypeStore = require('./store/LeaveTypeStore').default;
window.LeavesReportStore = require('./reports/leavesReport/LeavesReportStore').default;
window.LockTTMediator = require('./user/locktt/LockTTMediator').default;
window.BalanceRulesEditorContent = require('./controls/BalanceRulesEditorContent').default;
window.ExitConfirmationHandlersManager = require('./ExitConfirmationHandlersManager').default;
window.Link = require('./components/Link').default;
window.ProductWebSiteURLs = require('./constants').ProductWebSiteURLs;

const notificationsAccessRightsStrategy = require('./notifications/AccessRightsStrategy');
window.SubmitTTRightStrategy = notificationsAccessRightsStrategy.SubmitTTRightStrategy;
window.GenerateMoneyReportRightStrategy = notificationsAccessRightsStrategy.GenerateMoneyReportRightStrategy;
window.AccessToManagerScopesStrategy = notificationsAccessRightsStrategy.AccessToManagerScopesStrategy;
window.EditHierarchyRightStrategy = notificationsAccessRightsStrategy.EditHierarchyRightStrategy;

const ruleState = require('./notifications/RuleState');
window.PersonalTTRuleState = ruleState.PersonalTTRuleState;
window.UnsubmittedTTRuleState = ruleState.UnsubmittedTTRuleState;
window.DeadlineRuleState = ruleState.DeadlineRuleState;
window.EstimateRuleState = ruleState.EstimateRuleState;
window.ProjectBudgetRuleState = ruleState.ProjectBudgetRuleState;
window.PersonalEarningsRuleState = ruleState.PersonalEarningsRuleState;

window.EnterTTMediator = require('./user/entertt/Mediator').default

const atUtils = require("./atUtils");
window.escapeHtmlSymbols = atUtils.escapeHtmlSymbols;
window.unescapeHtmlSymbols = atUtils.unescapeHtmlSymbols;
window.concatStr = atUtils.concatStr;
window.truncateStringByLength = atUtils.truncateStringByLength;
window.stringComparator = atUtils.stringComparator;
window.stringComparatorCaseSensitive = atUtils.stringComparatorCaseSensitive;
window.nameComparator = atUtils.nameComparator;
window.numberComparator = atUtils.numberComparator;
window.trim = atUtils.trim;
window.leadZero = atUtils.leadZero;
window.formatRawSecondsOffset = atUtils.formatRawSecondsOffset;
window.makeMapAndOrderForEntitiesArray = atUtils.makeMapAndOrderForEntitiesArray;
window.makeMapForEntitiesArray = atUtils.makeMapForEntitiesArray;
window.isEmailValid = atUtils.isEmailValid;
window.compareDates = atUtils.compareDates;
window.compareNullableStrDates = atUtils.compareNullableStrDates;
window.areDatesEqual = atUtils.areDatesEqual;
window.makeHandler = atUtils.makeHandler
window.getStringWithUnifiedNewLineSymbol = atUtils.getStringWithUnifiedNewLineSymbol;
window.isNotEmpty = atUtils.isNotEmpty;
window.removeContextFromProductUrl = atUtils.removeContextFromProductUrl;
window.defer = atUtils.defer;
window.filterArrayByArrayOfIds = atUtils.filterArrayByArrayOfIds;

window.makeRpcCall = require("./util/jquery_rpc").default;
window.makeToast = require("./toasts/utils").toast
window.UserTime = require("./user_time").default;

const atBrowserUtils = require("./atBrowserUtils");
window.getBodyScrollLeft = atBrowserUtils.getBodyScrollLeft;
window.getBodyScrollTop = atBrowserUtils.getBodyScrollTop;
window.disableTextSelection = atBrowserUtils.disableTextSelection;
window.getCookie = atBrowserUtils.getCookie;
window.setCookie = atBrowserUtils.setCookie;
window.getArrayFromCookies = atBrowserUtils.getArrayFromCookies;
window.saveArrayIntoCookies = atBrowserUtils.saveArrayIntoCookies;
window.isLetterOrDigitSymbolPressed = atBrowserUtils.isLetterOrDigitSymbolPressed;
window.addClass = atBrowserUtils.addClass;
window.hasClass = atBrowserUtils.hasClass;
window.removeClass = atBrowserUtils.removeClass;
window.replaceClass = atBrowserUtils.replaceClass;
window.getEventObj = atBrowserUtils.getEventObj;
window.isKeyPressed = atBrowserUtils.isKeyPressed;
window.isTabPressed = atBrowserUtils.isTabPressed;
window.handleTab = atBrowserUtils.handleTab;
window.isEscapePressed = atBrowserUtils.isEscapePressed;
window.handleEscape = atBrowserUtils.handleEscape;
window.isEnterPressed = atBrowserUtils.isEnterPressed;
window.handleEnter = atBrowserUtils.handleEnter;
window.cancelBubble = atBrowserUtils.cancelBubble;
window.atImgPath = atBrowserUtils.atImgPath;
window.imgPath = atBrowserUtils.imgPath;
window.calculateCoords = atBrowserUtils.calculateCoords;
window.calculateObjectCoords = atBrowserUtils.calculateObjectCoords;
window.findPosX = atBrowserUtils.findPosX;
window.findPosY = atBrowserUtils.findPosY;
window.shiftTo = atBrowserUtils.shiftTo;
window.getClientSize = atBrowserUtils.getClientSize;
window.getObjectWidth = atBrowserUtils.getObjectWidth;
window.getObjectHeight = atBrowserUtils.getObjectHeight;
window.getInsideWindowWidth = atBrowserUtils.getInsideWindowWidth;
window.getInsideWindowHeight = atBrowserUtils.getInsideWindowHeight;
window.getViewport = atBrowserUtils.getViewport;
window.scrollToElementIfNeeded = atBrowserUtils.scrollToElementIfNeeded;
window.scrollWindowIfNeeded = atBrowserUtils.scrollWindowIfNeeded;
window.smoothlyScrollDownToElement = atBrowserUtils.smoothlyScrollDownToElement;
window.isMSIE = atBrowserUtils.isMSIE;
window.isIE8 = atBrowserUtils.isIE8;
window.showElementAt = atBrowserUtils.showElementAt;
window.onOutsideClick = atBrowserUtils.onOutsideClick;
window.fixIScrollInnerWheelEvent = atBrowserUtils.fixIScrollInnerWheelEvent;
window.setMouseDownOutsideHandler = atBrowserUtils.setMouseDownOutsideHandler;
window.calculateTooltipOffset = atBrowserUtils.calculateTooltipOffset;
window.calculateElementOffset = atBrowserUtils.calculateElementOffset;
window.calculateTooltipOffsetByItParameters = atBrowserUtils.calculateTooltipOffsetByItParameters;
window.doOnceOn = atBrowserUtils.doOnceOn;
window.doOnceOnWindowResize = atBrowserUtils.doOnceOnWindowResize;
window.whichButtonPressed = atBrowserUtils.whichButtonPressed;
window.preventDefault = atBrowserUtils.preventDefault;
window.setFocusIntoFieldWithPlaceholder = atBrowserUtils.setFocusIntoFieldWithPlaceholder;
window.scrollToElementInPopup = atBrowserUtils.scrollToElementInPopup;
window.enableTextSelectionBack = atBrowserUtils.enableTextSelectionBack;
window.createElement = atBrowserUtils.createElement;
window.createElementWithProperties = atBrowserUtils.createElementWithProperties;
window.assign = atBrowserUtils.assign;
window.px = atBrowserUtils.px;

const stringUtils = require("./util/StringUtils")
window.StringUtils = {
    insertBrakes: stringUtils.insertBrakes,
    cutLongText: stringUtils.cutLongText,
    cutNumberOfTextLines: stringUtils.cutNumberOfTextLines,
}

const storeUtils = require("./store/StoreUtils");
window.StoreUtils = {
    mergeCustomersProjectsFromRPC: storeUtils.mergeCustomersProjectsFromRPC,
    mergeCustomersProjectsFromJSP: storeUtils.mergeCustomersProjectsFromJSP,
    replaceUsersFromJSP: storeUtils.replaceUsersFromJSP,
    replaceUserGroupsFromJSP: storeUtils.replaceUserGroupsFromJSP,
    replaceTimeZoneGroupsFromJSP: storeUtils.replaceTimeZoneGroupsFromJSP
}

const userGroupSelectorUtil = require("./usersSelector/user_group_selector_util");
window.userComparator = userGroupSelectorUtil.userComparator;
window.buildUserSelectorTreeWithUserGroupsData = userGroupSelectorUtil.buildUserSelectorTreeWithUserGroupsData;
window.buildUserSelectorTreeWithTimeZoneGroupsData = userGroupSelectorUtil.buildUserSelectorTreeWithTimeZoneGroupsData;
window.getUserSelectorFeatureStrategy = userGroupSelectorUtil.getUserSelectorFeatureStrategy;

const keyCodes = require("./keyCodes");
window.KEY_CODE_UP = keyCodes.KEY_CODE_UP;
window.KEY_CODE_DOWN = keyCodes.KEY_CODE_DOWN;
window.KEY_CODE_ESC = keyCodes.KEY_CODE_ESC;
window.KEY_CODE_ENTER = keyCodes.KEY_CODE_ENTER;
window.KEY_CODE_TAB = keyCodes.KEY_CODE_TAB;
window.KEY_CODE_DEL = keyCodes.KEY_CODE_DEL;
window.KEY_CODE_SPACE = keyCodes.KEY_CODE_SPACE;
window.KEY_CODE_PAGE_UP = keyCodes.KEY_CODE_PAGE_UP;
window.KEY_CODE_PAGE_DOWN = keyCodes.KEY_CODE_PAGE_DOWN;

window.AT = {};
window.AT.SimpleSelectorPanel = require("./controls/selectorControls/at_simple_selector_panel").default;
window.AT.CustomerProjectSelectorPanel = require("./cp_selector/at_customer_project_selector_panel").default;
window.AT.UsersSelectorPanel = require("./usersSelector/at_users_selector_panel").default;
window.AT.ReportsSelectorUsersPanel = require("./reports/at_reports_selector_users_panel").default;
window.AT.AccessRightsUsersSelectorPanel = require("./usersSelector/at_user_selector_panel_with_ar").default;
window.AT.SharedUserButtonMenu = require("./controls/selectorControls/at_shared_user_button_menu.js").default;
window.AT.IconButton = require("./controls/at_icon_button").default;
window.AT.FlatButton = require("./controls/at_flat_button").default;
window.AT.GradientButton = require("./controls/at_gradient_button").default;
window.AT.SelectionHelper = require("./controls/selectorControls/selectionHelpers/at_selection_helper").default;
window.AT.GenericSelectorTreePropertiesController = require("./controls/selectorControls/GenericSelectorTreePropertiesController").default;
window.AT.SelectorTree = require("./controls/selectorControls/at_selector_tree").default;
window.AT.SimpleListSelectorTree = require("./controls/selectorControls/at_simple_list_selector_tree").default;
window.AT.SelectorTreeNode = require("./controls/selectorControls/at_selector_tree_node").default;
window.AT.SelectorTreeCheckbox = require("./controls/selectorControls/at_selector_tree_checkbox").default;
window.AT.TreeNodeHelper = require("./controls/selectorControls/at_tree_node_helper").default;
window.AT.GroupSelectorSwitcher = require("./controls/selectorControls/at_group_selector_switcher").default;
window.AT.ExtendedGroupSelectorSwitcher = require("./controls/selectorControls/ExtendedGroupSelectorSwitcher").default;
window.AT.SimpleUsersAndGroupsSelectionHelper = require("./controls/selectorControls/selectionHelpers/simple_users_and_groups_selection_helper").default;
window.AT.ComplicateUsersAndGroupsSelectionHelper = require("./controls/selectorControls/selectionHelpers/complicate_users_and_groups_selection_helper").default;
window.AT.HierarchySelectorDropdownButton = require("./controls/selectorControls/at_hierarchy_selector_dropdown_button").default;
window.AT.CustomerProjectSelectorTwoGenericOptionsPanel = require("./cp_selector/at_customer_project_two_generic_options_panel").default;
window.AT.AbstractDropdownButton = require("./controls/abstract_dropdown_button").default;
window.AT.DropdownButton = require("./controls/at_dropdown_button").default;
window.AT.DropdownListButton = require('./controls/dropdown_list_button').default
window.AT.AbstractPickerButton = require('./controls/dateControls/at_abstract_picker_button').default
window.AT.BaseDatePicker = require('./controls/dateControls/at_base_date_picker').default
window.AT.DatePicker = require('./controls/dateControls/at_date_picker').default
window.AT.WeekPicker = require('./controls/dateControls/at_week_picker').default
window.AT.SelectorDropdownButton = require('./controls/selectorControls/at_selector_dropdown_button').default
window.AT.ElasticTextArea = require('./controls/at_elastic_textarea').default
window.AT.ExtendedGroupsSelectorPanel = require('./administration/userManagement/userList/at_extended_groups_selector_panel').default
window.AT.GroupsSelectorPanel = require('./controls/at_groups_selector_panel').GroupsSelectorPanel
window.AT.SmartGroupsSelectorPanel = require('./controls/at_groups_selector_panel').SmartGroupsSelectorPanel
window.AT.ReportsSelectorUsersPanel = require("./reports/at_reports_selector_users_panel").default

window.AT.menu = {}
window.AT.menu.SpecialMenuMgr = require('./controls/at_specialMenuMgr').default
window.AT.menu.DatePickerMenu = require('./controls/dateControls/at_date_picker_menu').default
window.AT.menu.PickerMenu = require('./controls/dateControls/at_picker_menu').default
window.AT.menu.PickerItem = require('./controls/dateControls/at_picker_item').default
window.AT.menu.WeekPickerMenu = require('./controls/dateControls/at_week_picker_menu').default
window.AT.menu.WeekPickerItem = require('./controls/dateControls/at_week_picker_item').default

window.CustomCheckbox = require("./components/customCheckbox/CustomCheckbox").default;
window.CircleSpinner = require("./components/spinner/CircleSpinner").default;

window.ViewTTMediator = require("./user/viewtt/ViewTTMediator").default;

window.EditableCell = require('./administration/userManagement/userList/table/EditableCell.js').default;
window.EditableCellRenderer = require('./administration/userManagement/userList/table/EditableCellRenderer.js').default;
window.TaskBillingTypeCellRenderer = require('./addNewTasks/TaskBillingTypeCellRenderer.js').default;
window.TableTooltip = require('./controls/TableTooltip').default
window.SimpleTooltip = require('./SimpleTooltip').default

window.DelayTooltip = require('./controls/DelayTooltip').default

window.ATUserManagementMediator = require('./administration/userManagement/UserManagementMediator').default

window.UserTableRow = require('./administration/userManagement/userList/table/UserTableRow').default

window.TaskManagementStore = require('./taskManagement/TaskManagementStore').default;

const date_format = require('./date_format');
window.DateFormat = date_format.DateFormat;

window.UserATProfilePopup = require('./userProfile/UserATProfilePopup').default
window.ViewTTPageColumnChartGenerator = require('./user/viewtt/chart/ColumnChartGenerator').default
window.CopyUserSettingsSelector = require('./administration/userManagement/CopyUserSettingsSelector').default;
window.ViewTTStore = require("./user/viewtt/ViewTTStore").default;
window.TabularDataTableCell = require('./administration/userManagement/tabularDataTable/TabularDataTableCell').default
window.TabularDataTableRow = require('./administration/userManagement/tabularDataTable/TabularDataTableRow').default
window.TabularDataWithEffectiveDatesTableRow = require('./administration/userManagement/tabularDataTable/TabularDataWithEffectiveDatesTableRow').default
window.TabularDataTableCellValidator = require('./administration/userManagement/tabularDataTable/TabularDataTableCellValidator').default
window.WorkdayDurationsTableRow = require('./administration/userManagement/workScheduleTable/WorkdayDurationsTableRow').default
window.LoadingCell = require('./administration/userManagement/tabularDataTable/LoadingCell').default

const constants = require('constants');
window.CustomersProjectsSelectionQualifier = constants.CustomersProjectsSelectionQualifier;
window.startWorkFlowSettings = require('./administration/workflowSettings/index').default
window.startWorkSchedule = require('./administration/workSchedule/index').default
window.DescriptionUtil = require('./description_util').DescriptionUtil
window.CreateTaskDescriptionUtil = require('./description_util').CreateTaskDescriptionUtil
window.TaskManagementMediator = require('./taskManagement/Mediator').default

window.initApplication = require('./initApplication').default
window.initApplicationAP = require('../actiplans/js/initApplication').default
window.initGeneralSettings = require('./administration/initGeneralSettings').default;

window.openSupportForm = require('./support/supportForm/utils').openSupportForm;
window.EnterTTUrlUtils = require('./util/EnterTTUrlUtils').default;
window.LogoDropzone = require('./administration/customization/LogoDropzone').default;
window.ReportLogoDropzone = require('./administration/customization/ReportLogoDropzone').default;
window.ImageRequirementsPopup = require('./administration/customization/ImageRequirementsPopup').default
window.CookiesDisabledLoginPlug = require('./administration/login/CookiesDisabledLoginPlug').default

// actiPlans objects ******************************************************************
window.PageOverlayTipsManager = require('../actiplans/js/tips/PageOverlayTipsManager').default
window.UserListPage = require('../actiplans/js/administration/UserListPage').default;
window.EmailNotificationsPageOverlayTipsManager = require('../actiplans/js/tips/managers/EmailNotificationsPageOverlayTipsManager').default
window.LeaveTimePlanningPageOverlayTipsManager = require('../actiplans/js/tips/managers/LeaveTimePlanningPageOverlayTipsManager').default
window.LeaveTimeRequestPageOverlayTipsManager = require('../actiplans/js/tips/managers/LeaveTimeRequestPageOverlayTipsManager').default
window.APLeaveTypesPageOverlayTipsManager = require('../actiplans/js/tips/managers/LeaveTypesPageOverlayTipsManager').default
window.MySchedulePageOverlayTipsManager = require('../actiplans/js/tips/managers/MySchedulePageOverlayTipsManager').default
window.APSettingsPageOverlayTipsManager = require('../actiplans/js/tips/managers/SettingsPageOverlayTipsManager').default
window.APUserListPageOverlayTipsManager = require('../actiplans/js/tips/managers/UserListPageOverlayTipsManager').default

window.LeaveTimeBalancesPageOverlayTipsManager = require('../actiplans/js/tips/managers/reports/LeaveTimeBalancesPageOverlayTipsManager').default
window.BalanceHistoryPageOverlayTipsManager = require('../actiplans/js/tips/managers/reports/BalanceHistoryPageOverlayTipsManager').default
window.PastLeavesPageOverlayTipsManager = require('../actiplans/js/tips/managers/reports/PastLeavesPageOverlayTipsManager').default
window.APInviteSeveralUsersLightBox = require('../actiplans/js/administration/APInviteSeveralUsersLightBox').default
window.LeaveRequestsExportToCSVPanel = require('../actiplans/js/administration/corporateRequests/exportToCsv/LeaveRequestsExportToCSVPanel').default
window.downloadLeaveRequestsListCsv = require('../actiplans/js/administration/corporateRequests/exportToCsv/exporter').downloadLeaveRequestsListCsv

window.APReportsPage = require('../actiplans/js/reports/APReportsPage').default
window.APReportsPage.BalancesChartGenerator = require('../actiplans/js/reports/leaveTimeBalancesReportPage/chart/BalancesChartGenerator').default
window.APReportsPage.LeaveTimeChartGenerator = require('../actiplans/js/reports/leaveTimeBalancesReportPage/chart/LeaveTimeChartGenerator').default
window.APReportsPage.BalanceHistoryCSVConverter = require('../actiplans/js/reports/balanceHistoryPage/CSVConverter').default
window.APReportsPage.PastLeavesCSVConverter = require('../actiplans/js/reports/pastLeavesPage/CSVConverter').default
window.LeaveTimeDetailsTable = require('../actiplans/js/administration/leave_time_details_table').LeaveTimeDetailsTable

window.startICalendarFeeds = require('../actiplans/js/icalendar/index').default
// end of actiPlans objects  **********************************************************

// common objects *********************************************************************
window.InvitationDialog = require('./InvitationDialog').default
window.DropdownList = require('./controls/DropdownList').default
window.WorkdayDurationsEditor = require('./controls/WorkdayDurationsEditor').default
window.UserProfilePopup = require('./userProfile/UserProfilePopup').default
window.UserProfileSection = require('./userProfile/UserProfileSection').default
window.BaseUserInformationSection = require('./administration/userManagement/BaseUserInformationSection').default
window.BaseUserDataSection = require('./administration/userManagement/BaseUserDataSection').default
window.AccountInformationSection = require('./administration/userManagement/AccountInformationSection').default
window.CreateAccountInformationSection = require('./administration/userManagement/CreateAccountInformationSection').default
window.EditAccountInformationSection = require('./administration/userManagement/EditAccountInformationSection').default
window.CorporateScheduleCalculator = require('./controls/dateControls/CorporateScheduleCalculator').default
window.ScheduleCalculator = require('./controls/dateControls/ScheduleCalculator').default
window.DateSelector = require('./controls/dateControls/DateSelector').default
window.WeekSelector = require('./controls/dateControls/WeekSelector').default
window.HireDateWarningDlg = require('./administration/userManagement/HireDateWarning').default
window.TimeZoneGroupsListSelector = require('./controls/TimeZoneGroupsListSelector').default
window.TumblerSwitch = require('./controls/tumbler_switch').default
window.Table = require('./table/Table').default
window.TaskTableTemplate = require('./taskManagement/createLightbox/TaskTableTemplate').default
window.TableCell = require('./table/TableCell.js').default
window.TableCellRenderer = require('./table/TableCellRenderer.js').default;
window.TableMouseEventsHandler = require('./table/TableMouseEventsHandler').default;
window.TableRegion = require('./table/TableRegion').default;
window.NullTableRegion = require('./table/NullTableRegion').default;
window.TableRow = require('./table/TableRow').default;
window.TabularDataWithEffectiveDatesTable = require('./administration/userManagement/tabularDataTable/TabularDataWithEffectiveDatesTable').default
window.DefaultWorkStatusesContainer = require('./panels/user/accountSettings/workStatuses/components/WorkStatusesContainer').DefaultWorkStatusesContainer
window.TabularDataTable = require('./administration/userManagement/tabularDataTable/TabularDataTable').default
window.EffectiveDateCellRenderer = require('./administration/userManagement/tabularDataTable/EffectiveDateCellRenderer').default
window.RemoveRowCellRenderer = require('./administration/userManagement/tabularDataTable/RemoveRowCellRenderer').default;
window.EmptyRemoveRowCellRenderer = require('./administration/userManagement/tabularDataTable/EmptyRemoveRowCellRenderer').default;
window.RemoveRowWithConfirmationCellRenderer = require('./administration/userManagement/tabularDataTable/RemoveRowWithConfirmationCellRenderer').default;
window.DatePickerMenu = require('./controls/dateControls/DatePickerMenu').default
window.PageMediator = require('./PageMediator').default
window.WarningsController = require('./administration/userManagement/WarningsController').default
window.NumberFormatter = require('./number_formatter').default
window.ChartGenerator = require('./chart/ChartGenerator').default
window.PieChartGenerator = require('./chart/PieChartGenerator').default

window.BaseBalanceRulesControl = require('./controls/BalanceRulesEditor').BaseBalanceRulesControl
window.BalanceRulesEditor = require('./controls/BalanceRulesEditor').BalanceRulesEditor
window.AdvancedBalanceRulesEditor = require('./controls/BalanceRulesEditor').AdvancedBalanceRulesEditor
window.BalanceRulesTooltip = require('./controls/BalanceRulesEditor').BalanceRulesTooltip
window.BalanceRulesViewer = require('./controls/BalanceRulesEditor').BalanceRulesViewer
window.BalanceRulesEditorDialog = require('./controls/BalanceRulesEditor').BalanceRulesEditorDialog
window.BalanceRulesManager = require('./controls/BalanceRulesEditor').BalanceRulesManager
window.BALANCE_RULES_VALUES = require('./controls/BalanceRulesEditor').BALANCE_RULES_VALUES

window.BalanceHistory = require('./balanceHistory/BalanceHistoryTable').BalanceHistory

window.checkReloadNeededAfterGetAssignedUsersRequest = require('./administration/userlist_util').checkReloadNeededAfterGetAssignedUsersRequest
window.formatAssignApproversCellText = require('./administration/userlist_util').formatAssignApproversCellText
window.createApproversSortingProcessor = require('./administration/userlist_util').createApproversSortingProcessor
window.UserListConfirmation = require('./administration/userManagement/UserListConfirmation').default;

window.CreateUserLightBox = require('./administration/userManagement/CreateUserLightBox').default;
window.UserDataLightBox = require('./administration/userManagement/UserDataLightBox').default;
window.LeaveBalanceEditor = require('./administration/userManagement/LeaveBalanceEditor').default;
window.SmartField = require('./controls/SmartField').default;
window.DecimalField = require('./controls/DecimalField').default;
window.BaseUsersSelector = require('./controls/BaseUsersSelector').default
window.json2csv = require('./json2csv/json2csv').default

//TODO temporary added
window.LeaveReportColumnsFormatSelector = require('./controls/LeaveReportColumnsFormatSelector').default
window.BaseTableDataConverter = require('./reports/table/BaseTableDataConverter')
window.PDFDefinitionColumnBuilder  = require('./pdf/BasePDFDefinitionColumnBuilder').default
window.BaseParametersFormattingStrategy   = require('./parametersFormatting/BaseParametersFormattingStrategy').default
window.DateRangeFormattingStrategy   = require('./parametersFormatting/DateRangeFormattingStrategy').default
window.ChartParametersFormattingStrategy  = require('./reports/charts/parametersFormatters/ChartParametersFormattingStrategy').default
window.LeavesChartParametersFormatter  = require('./reports/leavesReport/pdfPreview/ParametersFormattingStrategy').default
window.ChartParametersFormatter  = require('./reports/charts/parametersFormatters/ChartParametersFormatter').default
window.LeavesReportUtils = require('./reports/leavesReport/LeavesReportUtils').default

window.RowType = require('./reports/table/RowType').RowType
window.ColumnsConfig = require('./reports/overtimeReport/ColumnsConfig').ColumnsConfig

window.BaseReportFormatUtils = require('./reports/FormatUtils').default
window.OvertimeReportFormatUtils = require('./reports/overtimeReport/FormatUtils').default
window.LeavesReportFormatUtils = require('./reports/leavesReport/FormatUtils').default

window.LeavesReportPDFSettingsPreview = require('./reports/leavesReport/pdfPreview/PDFSettingsPreview').default
window.LeavesReportPDFGenerator = require('./pdf/leavesReport/PDFGenerator').default
window.LeavesReportPDFPreviewLightbox = require('./reports/leavesReport/pdfPreview/PDFPreviewLightbox').default
window.APReportsPagePDFPreviewLightbox = require('../actiplans/js/reports/leaveTimeBalancesReportPage/pdfPreview/PDFPreviewLightbox').default
window.LeavesReportTableDataConverter = require('./reports/leavesReport/TableDataConverter').default
window.LeavesReportPDFPreviewLightboxController = require('./reports/leavesReport/pdfPreview/PDFPreviewLightboxController').default

window.ViewTTPDFPreviewLightboxController = require('./user/viewtt/PDFPreviewLightboxController').default

window.OvertimeReportPDFPreviewLightbox = require('./reports/overtimeReport/PDFPreviewLightbox').default
window.OvertimeReportPDFGenerator = require('./pdf/overtimeReport/PDFGenerator').default
window.OvertimeReportTableDataConverter = require('./reports/overtimeReport/TableDataConverter').default

window.EVAReportPDFPreviewLightbox = require('./reports/estimatedVsActualReport/PDFPreviewLightbox').default
window.EVAReportPDFGenerator = require('./pdf/evaReport/PDFGenerator').default
window.EVAReportTableDataConverter = require('./reports/estimatedVsActualReport/Table/TableDataConverter').default

window.PDFImageCache = require('./pdf/PDFImageCache').default

window.ChartMediator = require('./reports/charts/ChartMediator').default

window.OldReportMediator = require('./reports/OldReportMediator').default
// window.OldBaseFormMediator = require('./reports/OldBaseFormMediator').default

window.ReportConfigs = require('./reports/ReportConfigs').default
window.BaseFormMediator = require('./reports/BaseFormMediator').default
window.ReportMediator = require('./reports/ReportMediator').default
window.OvertimeFormMediator = require('./reports/OvertimeFormMediator').default
window.OvertimeReportMediator = require('./reports/OvertimeReportMediator').default
window.BudgetedVsActualReportMediator = require('./reports/BudgetedVsActualReportMediator').default
window.LeaveTimeFormMediator = require('./reports/LeaveTimeFormMediator').default
window.EstimatedVsActualFormMediator = require('./reports/EstimatedVsActualFormMediator').default
window.LeavesReportMediator = require('./reports/LeavesReportMediator').default
window.StaffOutputFormMediator = require('./reports/StaffOutputFormMediator').default
window.StaffOutputReportMediator = require('./reports/StaffOutputReportMediator').default
window.TTDetailReportMediator = require('./reports/TTDetailReportMediator').default
window.TTDetailFormMediator = require('./reports/TTDetailFormMediator').default
window.CostReportMediator = require('./reports/CostReportMediator').default
window.CostFormMediator = require('./reports/CostFormMediator').default
window.BillingSummaryFormMediator = require('./reports/BillingSummaryFormMediator').default
window.BillingSummaryReportMediator = require('./reports/BillingSummaryReportMediator.js').default
window.InvoiceFormMediator = require('./reports/InvoiceFormMediator.js').default
window.ProfitLossFormMediator = require('./reports/ProfitLossFormMediator.js').default
window.ProfitLossReportMediator = require('./reports/ProfitLossReportMediator.js').default

window.ReportEditConfigController = require('./reports/edit_config_controller/ReportEditConfigController').default
window.LeavesReportEditConfigController = require('./reports/edit_config_controller/leaves/LeavesReportEditConfigController').default
window.ReportUserSelectorButton = require('./controls/ReportUserSelectorButton').default
window.ReportTimeTrackStatusFilter = require('./controls/ReportTimeTrackStatusFilter').default
window.ChooseTypeSelector = require('./controls/invoice_billing_summary_choose_type').default
window.DisplayedDataSelector = require('./controls/displayed_data_radiogroup_controls_bs_report').default
window.InvoiceEditResultConfigController = require('./reports/edit_config_controller/InvoiceEditResultConfigController').default
window.ReportConfig = require('./reports/ReportConfig').default

window.CSVParametersBuilder = require('./reports/preview/csv/CSVParametersBuilder').default

window.GroupingSelector = require('./reports/GroupingSelector').default
window.ThreeLevelReportGroupingSelector = require('./reports/ThreeLevelReportGroupingSelector').default
window.LeavesEditFormConfigController = require('./reports/edit_config_controller/leaves/LeavesEditFormConfigController').default

window.ATReportParamsStringBuilder = require('./reports/reportParamsStringBuilder/ATReportParamsStringBuilder').default
window.APReportParamsStringBuilder = require('./reports/reportParamsStringBuilder/APReportParamsStringBuilder').default

window.APReportsPageLeaveTimeBalancesReportPageStore = require('./reports/leavesReport/LeavesReportStore').default

window.downloadJsonAsCSV = require('./csv/utils').downloadJsonAsCSV
window.downloadPDF = require('./pdf/utils').downloadPDF
window.PasswordPolicyManager = require('./util/passwords/PasswordPolicyManager').default;
window.PasswordAsyncValidator = require('./util/passwords/PasswordAsyncValidator').default;
window.getPasswordValidator = require('./util/passwords/PasswordAsyncValidator').getPasswordValidator;
window.PasswordHintTooltip = require('./util/passwords/PasswordHintTooltip').default;

window.DatesIterator = require('./administration/workSchedule/utils').DatesIterator;
window.MonthIterator = require('./administration/workSchedule/utils').MonthIterator;

window.emitUserEvent = require('./userEvents/emitUserEvent').default
window.UserEventsMap = require('./userEvents/UserEventsMap').UserEventsMap

window.NextBridge = require('./next/NextBridge').default;
// end of common object ***************************************************************



// WEBPACK FOOTER //
// ./web/js/globals.js